import React, { Component } from 'react';
import './footer.css';

class Footer extends Component {    
    render() {
        return (
            <>
                <button className="btn pre-btn">
                    <span className="icon-wrap">
                        <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                        </svg>
                    </span>
                    <b>이전</b>
                </button>
                <div className="page-info"><span className="current-page">1</span>&nbsp;/&nbsp;<span className="total-page">30</span></div>
                <button className="btn next-btn">
                    <b>다음</b>
                    <span className="icon-wrap">
                        <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                        </svg>
                    </span>
                </button>
            </>
        );
    }
}

export default Footer;